export default __webpack_public_path__ + "2272c1a3f0676b341bba2ff53cdf2492.svg";